/**
 * Sanitizes a filename to ensure S3 compatibility by removing or replacing
 * problematic characters.
 *
 * @param {string} filename - The original filename to sanitize
 * @returns {string} The sanitized filename safe for S3 upload
 *
 * @example
 * sanitizeFilename("château file (1).jpg") // Returns "chateau_file_1.jpg"
 * sanitizeFilename("my  file.pdf") // Returns "my_file.pdf"
 */
export function sanitizeFilename(filename) {
  return filename
    .normalize("NFD") // Decompose unicode (é -> e + ´)
    .replace(/[\u0300-\u036f]/g, "") // Remove combining diacritical marks
    .replace(/\s+/g, "_") // Spaces to underscores
    .replace(/[^a-zA-Z0-9._-]/g, "_") // Other special chars to underscores
    .replace(/_+/g, "_") // Collapse multiple underscores
    .replace(/^_+|_+$/g, ""); // Trim leading/trailing underscores
}
